export default __webpack_public_path__ + "static/media/sinbad_logo.85cc5125.png";